__webpack_require__.p = "https://uat.wishliz.com/";